<template>
  <div :class="props.size">
    <p :class="(stacked ? 'flex flex-col gap-1 ' : 'flex flex-row gap-1 ') + props.class">
      <span :class="labelClass">{{ label }}: </span>
      <span :class="displayClass">{{ display }}</span>
    </p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label: string;
  display?: string;
  size?: string;
  class?: string;
  labelClass?: string;
  displayClass?: string;
  stacked?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  display: "",
  size: "w-full",
  class: "",
  labelClass: "font-bold italic",
  displayClass: "",
  stacked: false,
});
</script>
